export { default, getStaticProps } from 'ui/pages/privacy'